import { AccountingReportCycle } from "@common/constants";
import {
    SchedulesReportMethod,
    SchedulesReportLayout,
    SchedulesReportRevenueSubMode,
    SchedulesReportRows,
} from "@common/types/reports/schedules-report";
import {
    SchedulesReportColumn,
    SchedulesReportView,
} from "@common/types/views/schedulesReportView";
import {
    NamedView,
    ViewDensity,
    ViewOptions,
    ViewType,
} from "@common/types/views/views";

export const PERIOD_ROLLFORWARD_VIEW_ID = "period-rollforward";
export const WATERFALL_BY_MONTH_VIEW_ID = "waterfall-by-month";

// Term dates start hidden; users reveal them from the column settings.
export const SCHEDULES_REPORT_DEFAULT_COLUMNS: SchedulesReportView["columns"] =
    [{ id: SchedulesReportColumn.TITLE, options: { pin: "left" } }];

const FIXED_COLUMN_IDS: string[] = Object.values(SchedulesReportColumn);

/** Keeps only the fixed columns and guarantees the pinned title column. */
export function normalizeSchedulesReportViewColumns(
    columns: SchedulesReportView["columns"] | undefined,
): SchedulesReportView["columns"] {
    const fixedColumns = (columns ?? []).filter(
        (column) =>
            FIXED_COLUMN_IDS.includes(column.id) &&
            column.id !== SchedulesReportColumn.TITLE,
    );
    return [...SCHEDULES_REPORT_DEFAULT_COLUMNS, ...fixedColumns];
}

export const SCHEDULES_REPORT_DEFAULT_VIEW_OPTIONS: ViewOptions = {
    density: ViewDensity.LG,
};

export const SCHEDULES_REPORT_DEFAULT_VIEW_FILTERS: SchedulesReportView["filters"] =
    {
        scheduleLayout: SchedulesReportLayout.rollforward,
        scheduleRows: SchedulesReportRows.bySchedule,
        revenueSubMode: SchedulesReportRevenueSubMode.all,
        scheduleMethod: SchedulesReportMethod.all,
        datePreset: "this_year_to_date",
    };

interface KickViewParams {
    id: string;
    name: string;
    filters: SchedulesReportView["filters"];
}

function createKickView({
    id,
    name,
    filters,
}: KickViewParams): NamedView<SchedulesReportView> {
    return {
        id,
        name,
        type: ViewType.SCHEDULES_REPORT,
        columns: SCHEDULES_REPORT_DEFAULT_COLUMNS,
        filters: { ...SCHEDULES_REPORT_DEFAULT_VIEW_FILTERS, ...filters },
        options: SCHEDULES_REPORT_DEFAULT_VIEW_OPTIONS,
    };
}

export const BUILT_IN_SCHEDULES_REPORT_VIEWS: Array<
    NamedView<SchedulesReportView>
> = [
    createKickView({
        id: PERIOD_ROLLFORWARD_VIEW_ID,
        name: "Period rollforward",
        filters: {
            scheduleLayout: SchedulesReportLayout.rollforward,
            datePreset: "this_year_to_date",
        },
    }),
    createKickView({
        id: WATERFALL_BY_MONTH_VIEW_ID,
        name: "Waterfall by month",
        filters: {
            scheduleLayout: SchedulesReportLayout.waterfall,
            cycle: AccountingReportCycle.MONTH,
            datePreset: "this_year",
        },
    }),
];
